export function toFuseExactSearchPattern(value: string): string {
  return `=${JSON.stringify(value)}`;
}
